import { BreadcrumbLink as ChakraBreadcrumbLink } from '@chakra-ui/react';
import { Text } from '../typography';

export type BreadcrumbLinkProps = {
    children: string;
    href: string;
};

export const BreadcrumbLink = ({ children, href }: BreadcrumbLinkProps): JSX.Element => (
    <ChakraBreadcrumbLink
        href={href}
        aria-label={children}
        display="flex"
        alignItems="center"
        color="slt-pepper.1000"
        mr={1}
        _hover={{
            textDecoration: 'underline',
            textDecorationColor: 'slt-pepper.1000',
            textUnderlineOffset: '4px',
        }}
    >
        <Text size="small" color="slt-pepper.1000">
            {children}
        </Text>
    </ChakraBreadcrumbLink>
);
